<template>
  <div>
    <ad></ad>
    <div class="content">
      <inner-nav :innerData="navList[6]" :innerTitle="navList[6].navChildList[1].name" :innerLink="navList[6].navChildList[1].toLink"></inner-nav>
      <div class="report-content">
        <div class="report-detail">
          <ul>
            <li>
              举报方式
            </li>
            <li>
              <img src="../../../static/img/icon-mailbox.png" alt="">
              <p>廉洁举报邮箱</p>
              <p>{{reportInfo.email}}</p>
              <div></div>

            </li>
            <li>
              <img src="../../../static/img/icon-tel.png" alt="">
              <p>电话举报</p>
              <p>{{reportInfo.phone}}</p>
              <div></div>

            </li>
            <li>
              <img src="../../../static/img/icon-letter.png" alt="">
              <p>信件举报</p>
              <p>{{reportInfo.address}}</p>
              <div></div>

            </li>

          </ul>
          <div class="report-promise">
            <div class="report-promise-title">
              <img src="../../../static/img/path.png" alt="">
              <div>
                <h1>承诺</h1>
                <p>对于举报者的个人信息及举报内容严格保密！</p>
              </div>
            </div>
            <div class="report-promise-content">
              <h2>举报须知</h2>
              <ul>
                <li>
                  <h3>《霏凡集团商业行为准则》</h3>
                  <p> 为霏凡集团对于员工在道德行为规范的层面的底线要求！
                    <router-link to="/main/contact/reportDetail" tag="span">了解详情</router-link>
                  </p>
                </li>
                <li>
                  <h3>举报范围</h3>
                  <p>  “廉洁举报”仅限于对霏凡集团员工违反《霏凡集团商业行为准则》行为的举报，其他投诉请通过霏凡集团官网“客户服务”客户热线解决。</p>
                </li>
                <li>
                  <h3>举报责任</h3>
                  <p> 1.举报人应遵守国家法律法规，不得损害他人合法利益。 <br>
                    2.举报内容应当客观公正，不得捏造、歪曲事实，不得陷害他人。</p>
                </li>
                <li>
                  <h3>重要提示</h3>
                  <p> 1.鼓励实名举报，我们承诺对实名举报的个人信息及举报内容严格保密，并对调查结果给予及时反馈。<br>
                    2.举报人应尽可能说明事情的基本经过，举报对象的名称、地址、具体当事人，并提供人利益或公司利益受到侵害的证据或其他有关资料。</p>
                </li>

              </ul>
            </div>
          </div>
        </div>


      </div>

    </div>
  </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  export default {
    name: "",
    data(){
      return {
        reportInfo: {}
      }
    },
    components: {
      ad,
      InnerNav
    },
    created(){
      this.$http.get(`/outer/report/getReport.do`).then((res)=>{
          this.reportInfo=res.data
      })
    }
  }
</script>

<style scoped lang="less">
  .report-content{
    padding-bottom: .4rem;
    padding-top:.3rem;
    width:12rem;
      .report-detail{
        overflow: hidden;
        clear: both;
        width:12rem;
          >ul{
            width:4rem;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            float: left;
             li{
               height:2.7rem;
               width:100%;
               padding:0 .5rem;
               padding-top:.7rem;
               background: #E3E5EC;
               text-align: center;
               color:#333333;
               position: relative;
               -webkit-box-sizing: border-box;
               -moz-box-sizing: border-box;
               box-sizing: border-box;
                img{
                  width:.5rem;
                  height:.5rem;
                  display: block;
                  margin: 0 auto;
                }
                p:nth-child(2){
                  font-size:.16rem;
                  font-family:PingFangSC-Medium;
                  font-weight:500;
                  line-height:.28rem;
                }
                p:nth-child(3){
                  font-size:.14rem;
                  font-family:PingFangSC-Regular;
                  font-weight:400;
                  color:rgba(51,51,51,1);
                  line-height:.2rem;
                }
                div{
                  width:3rem;
                  height:.06rem;
                  background:rgba(198,203,210,1);
                  position: absolute;
                  bottom:0;
                }
             }
             li:first-child{
               height:2rem;
               background:rgba(198,203,210,1);
               font-size:.2rem;
               color:#333333;
               font-family:PingFangSC-Medium;
               font-weight:500;
               color:rgba(51,51,51,1);
               line-height:.6rem;
               text-align: center;
             }
             li:last-child{
               div{
                 display: none;
               }

             }
          }
          .report-promise{
            width:8rem;
            float: right;
              .report-promise-title{
                 position: relative;
                 width:100%;
                 height:2rem;
                  img{
                    position: absolute;
                    top:0;
                    left:0;
                    height:100%;
                    width:100%;
                  }
                  div{
                    color:#333;
                    position: absolute;
                    top:0;
                    left:0;
                    width:100%;
                    height:100%;
                    z-index: 1;
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    padding:.69rem .9rem;
                      h1{
                        font-size:.3rem;
                        font-family:PingFangSC-Medium;
                        font-weight:500;
                        line-height:.36rem;
                      }
                      p{
                        font-size:.14rem;
                        font-family:PingFangSC-Regular;
                        font-weight:400;
                        line-height:.28rem;
                      }

                  }
               }
              .report-promise-content{
                background: #F9FAFC;
                width:8rem;
                height:8.12rem;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                padding:0 .34rem;
                  h2{
                    font-size:.2rem;
                    font-family:PingFangSC-Medium;
                    font-weight:500;
                    color:rgba(51,51,51,1);
                    line-height:.8rem;
                    border-bottom:1px solid #ccc;
                  }
                  ul{
                    width:100%;
                      li{
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        width:100%;
                        padding:.5rem 0;
                          h3{
                            font-size:.16rem;
                            font-family:PingFangSC-Medium;
                            font-weight:500;
                            color:rgba(51,51,51,1);
                            line-height:.32rem;
                          }
                          p{
                            font-size:.14rem;
                            font-family:PingFangSC-Regular;
                            font-weight:400;
                            color:rgba(102,102,102,1);
                            line-height:.28rem;
                              span{
                                cursor: pointer;
                                color: #333;
                                border:1px solid #666;
                                line-height:.3rem;
                                font-size:.14rem;
                                padding: .05rem .2rem;
                                -webkit-border-radius:.3rem;
                                -moz-border-radius:.3rem;
                                border-radius:.3rem;
                              }
                          }
                      }
                  }
              }
          }

      }


  }



</style>



// WEBPACK FOOTER //
// src/pages/contact/report.vue